import { SCREEN_NAME, CLICK_ACTIONS, IMPRESSION_ACTIONS } from "@cart-client/analytics/constants";
import { AnalyticsContextValue } from "@swiggy-private/checkout-core";

export const COOKING_REQUEST_STATE = {
    ADD: "Add Cooking Request",
    EDIT: "Edit Cooking Request",
};

// Impression when half-card special instruction is shown
export const impressionSpecialInstructionsPill = ({
    isEdit,
    cartId,
    sid,
    rid,
    impressionEvent,
}: {
    isEdit: boolean;
    cartId: string;
    sid: string;
    rid: string;
    impressionEvent: AnalyticsContextValue["impressionEvent"];
}): void => {
    impressionEvent({
        category: SCREEN_NAME.CHECKOUT,
        action: IMPRESSION_ACTIONS.IMPRESSSION_SPECIAL_INSTRUCTIONS,
        label: isEdit ? COOKING_REQUEST_STATE.EDIT : COOKING_REQUEST_STATE.ADD,
        extraParams: JSON.stringify({ cartId, sid, rid }),
    });
};

// Click: submit request from half-cart
export const clickSpecialInstructionsPill = ({
    isEdit,
    cartId,
    sid,
    rid,
    clickEvent,
}: {
    isEdit: boolean;
    cartId: string;
    sid: string;
    rid: string;
    clickEvent: AnalyticsContextValue["clickEvent"];
}): void => {
    clickEvent({
        category: SCREEN_NAME.CHECKOUT,
        action: CLICK_ACTIONS.CLICK_SPECIAL_INSTRUCTIONS,
        label: isEdit ? COOKING_REQUEST_STATE.EDIT : COOKING_REQUEST_STATE.ADD,
        extraParams: JSON.stringify({ cartId, sid, rid }),
    });
};

// Impression when half-card special instruction is shown
export const impressionHalfCardSpecialInstruction = ({
    isEdit,
    cartId,
    sid,
    rid,
    impressionEvent,
}: {
    isEdit: boolean;
    cartId: string;
    sid: string;
    rid: string;
    impressionEvent: AnalyticsContextValue["impressionEvent"];
}): void => {
    impressionEvent({
        category: SCREEN_NAME.CHECKOUT,
        action: IMPRESSION_ACTIONS.IMPRESSION_HALF_CART_SPECIAL_INSTRUCTION,
        label: isEdit ? COOKING_REQUEST_STATE.EDIT : COOKING_REQUEST_STATE.ADD,
        extraParams: JSON.stringify({ cartId, sid, rid }),
    });
};

// Click: submit request from half-cart
export const clickHalfCardSubmitRequest = ({
    cartId,
    sid,
    rid,
    clickEvent,
}: {
    cartId: string;
    sid: string;
    rid: string;
    clickEvent: AnalyticsContextValue["clickEvent"];
}): void => {
    clickEvent({
        category: SCREEN_NAME.CHECKOUT,
        action: CLICK_ACTIONS.CLICK_HALF_CART_SUBMIT_REQUEST,
        label: COOKING_REQUEST_STATE.ADD,
        extraParams: JSON.stringify({ cartId, sid, rid }),
    });
};

// Click: remove request from half-cart
export const clickHalfCardRemoveRequest = ({
    cartId,
    sid,
    rid,
    clickEvent,
}: {
    cartId: string;
    sid: string;
    rid: string;
    clickEvent: AnalyticsContextValue["clickEvent"];
}): void => {
    clickEvent({
        category: SCREEN_NAME.CHECKOUT,
        action: CLICK_ACTIONS.CLICK_HALF_CART_REMOVE_REQUEST,
        label: COOKING_REQUEST_STATE.EDIT,
        extraParams: JSON.stringify({ cartId, sid, rid }),
    });
};

// Click: update request from half-cart
export const clickHalfCardUpdateRequest = ({
    cartId,
    sid,
    rid,
    clickEvent,
}: {
    cartId: string;
    sid: string;
    rid: string;
    clickEvent: AnalyticsContextValue["clickEvent"];
}): void => {
    clickEvent({
        category: SCREEN_NAME.CHECKOUT,
        action: CLICK_ACTIONS.CLICK_HALF_CART_UPDATE_REQUEST,
        label: COOKING_REQUEST_STATE.EDIT,
        extraParams: JSON.stringify({ cartId, sid, rid }),
    });
};

// Click: close half-cart
export const clickHalfCardClose = ({
    isEdit,
    cartId,
    sid,
    rid,
    clickEvent,
}: {
    isEdit: boolean;
    cartId: string;
    sid: string;
    rid: string;
    clickEvent: AnalyticsContextValue["clickEvent"];
}): void => {
    clickEvent({
        category: SCREEN_NAME.CHECKOUT,
        action: CLICK_ACTIONS.CLICK_HALF_CART_CLOSE,
        label: isEdit ? COOKING_REQUEST_STATE.EDIT : COOKING_REQUEST_STATE.ADD,
        extraParams: JSON.stringify({ cartId, sid, rid }),
    });
};
